import { FileInfoDto, FileType, QueryFactory } from '@lmt/shared-types';
import {
  VersionItem,
  VersionItemProps,
} from '@lmt/unicorn-shared/app/components/patients/profile/cases/components/documents/VersionItem';
import React, { FC, useMemo } from 'react';

import styles from './VersionsList.module.scss';
import { keepPreviousData } from '@tanstack/react-query';

export type VersionsListProps = {
  groupId?: string;
  // If `undefined` or returns `false`, then `defaultOnClick` (using `useFileCallbacks`) is called
  onVersionClick?: (file: FileInfoDto) => boolean;
  highlightCurrentVersion?: boolean;
};

export const VersionsList: FC<VersionsListProps> = (props) => {
  const { onVersionClick, highlightCurrentVersion, groupId } = props;

  if (!groupId) {
    throw new Error('fileId is empty in VersionsList');
  }

  const versionsData = QueryFactory.FileQuery.useGetVersionHistoryQuery(
    groupId,
    { placeholderData: keepPreviousData },
  );

  const versionInfos = useMemo(() => {
    const result = versionsData.data
      ?.map(
        (value, index, array): VersionItemProps => ({
          fileInfo: value,
          nameChangedFrom:
            value.type !== FileType.DocumentDraft &&
            index != 0 &&
            array[index - 1].name != value.name
              ? array[index - 1].name
              : undefined,
          isCurrentVersion: false,
          onClick: onVersionClick ? () => onVersionClick!(value) : undefined,
        }),
      )
      .sort((a, b) => b.fileInfo.versionNumber - a.fileInfo.versionNumber);
    if (result && result.length > 0 && highlightCurrentVersion) {
      if (result[0].fileInfo.type !== FileType.DocumentDraft) {
        result[0].isCurrentVersion = true;
      } else if (result.length > 1) {
        result[1].isCurrentVersion = true;
      } else {
        result[0].isCurrentVersion = true;
      }
    }
    return result;
  }, [versionsData.dataUpdatedAt]);

  return (
    <div className={styles.body}>
      {versionInfos?.map((x) => (
        <VersionItem {...x} key={x.fileInfo.versionNumber} />
      ))}
    </div>
  );
};
